import { isDevMode } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AppState, appFeature } from '@app/core/store/app.reducer';

export interface State {
  app: AppState;
}

export const reducers: ActionReducerMap<State> = {
  app: appFeature.reducer
};

export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
